import { select, takeEvery } from 'redux-saga/effects';
import { RootState } from '../..';
import { COMMON_ERROR } from '../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';
import SendRequest from '../../../shared/services/sendRequest.service';
import { centeredNotification } from '../../../utils/utility';
import { NewAdmissionState } from '../../models/newAdmissionModel';
import actionTypes from '../../types/fileTypes';

export function* downloadFile({ guid }: any): Generator {
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/File/Download`;
  const downloadData: any = yield sendRequest.post(url, { guid });
  const { fileBytes, fileName, isSuccess, errorMsg } = downloadData;

  if (isSuccess && fileName) {
    const splittedFile = fileName?.split('.');
    const extension = splittedFile[splittedFile.length - 1]?.toLowerCase();
    let mimeType = '';
    if (extension === 'pdf') {
      mimeType = 'application/pdf';
    } else if (['png', 'jpg', 'jpeg'].indexOf(extension) >= 0) {
      mimeType = 'image/' + extension;
    }
    const linkSource = 'data:' + mimeType + ';base64,' + fileBytes;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  } else {
    centeredNotification(errorMsg);
  }
}
function* previewFile({ guid, onCallback }: any): Generator {
  const getPDFViewer = onCallback;
  const sendRequest = SendRequest.instance;
  try {
    const url = `${GLOBAL_URL.CRM_BASE_URL}/Provider/File/Download`;
    const response: any = yield sendRequest.post(url, {guid}, {
      isShowErrorInInterceptor: false,
    });
    const { isSuccess, errorMessage } = response || {};

    if (isSuccess) {
      getPDFViewer(response);
    } else {
      centeredNotification(errorMessage, 'error');
    }
  } catch (e) {
    console.error(e);
  }
}
export function* downloadAllFiles( {attachGuids}: any): Generator {
  const {downloadDocumentGuidList}: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/File/DownloadZip`;
  const downloadData: any = yield sendRequest.post(url, { attachGuids: downloadDocumentGuidList });
  const { fileBytes, fileName, isSuccess, errorMessage } = downloadData;
  if (isSuccess) {
    const linkSource = 'data:' + 'application/zip' + ';base64,' + fileBytes;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  } else {
    centeredNotification(errorMessage, 'error');
  }
}

export function* hisDownloadAllFiles({ payload }: any): Generator {
  const sendRequest = SendRequest.instance;
  const url = `${GLOBAL_URL.CRM_BASE_URL}Provider/File/Download`;
  const downloadData: any = yield sendRequest.post(url, { attachGuids: payload?.fileGuid, guid: payload?.guid });
  const { fileBytes, fileName, isSuccess, errorMessage } = downloadData;
  if (isSuccess) {
    const linkSource = 'data:' + 'application/pdf' + ';base64,' + fileBytes;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    downloadLink.remove();
  } else {
    centeredNotification(errorMessage, 'error');
  }
}

export function* getDocumentType({ request, onSuccess, onError }: any): Generator {
  const sendRequest = SendRequest.instance;
  try {
    const buddhimedRes: any = yield sendRequest
      .post<any, any>(GLOBAL_URL.CRM_BASE_URL + 'Provider/File/BuddhimedResponse', request, { isShowErrorInInterceptor: false });
    const { isSuccess = false, uploadedDetails = [] } = buddhimedRes || {};

    if (isSuccess && uploadedDetails?.length) {
      onSuccess(uploadedDetails);
    } else {
      onError();
    }
  } catch (err) {
    onError();
  }
}
function* getMobileOtp({ payload }: any): Generator {
  const { getMobileOtpNo } = payload;
  const sendRequest = SendRequest.instance;
  const {mobileNumberValue}: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const mobileNumber = mobileNumberValue?.split('+91 ');
  const request: any = {
    IsDocumentShare: true,
    mobileNo: mobileNumber[1].split(' ').join(''),
  };
  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.HEALTHLOCKER_URL}api/Auth/FindUserandSendOTP`, request,
      { isShowErrorInInterceptor: false });
      getMobileOtpNo(response);
  } catch (e) {
    getMobileOtpNo({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}
function* verifyMobileOtp({ payload }: any): Generator {
  const { verifyMobileOtpNumber } = payload;
  const sendRequest = SendRequest.instance;
  const {mobileNumberValue, mobileOtp, encryptedTxn}: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const mobileNumber = mobileNumberValue?.split('+91 ');

  const request: any = {
    otp: mobileOtp,
    encryptedToken: encryptedTxn,
    phoneNumber: mobileNumber[1].split(' ').join(''),
  };
    const response: any = yield sendRequest.post(`${GLOBAL_URL.HEALTHLOCKER_URL}api/Auth/Login`, request,
      { isShowErrorInInterceptor: false });
      verifyMobileOtpNumber(response);
}
function* getAadharOtp({ payload }: any): Generator {
  const { getAadharOtpNo } = payload;
  const sendRequest = SendRequest.instance;
  const {aadharNumberValue}: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const request: any = {
    aadhaar: aadharNumberValue,
  };
  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.CRM_BASE_URL}Health/Mobile/Aadhar/GenerateOTP`, request,
      { isShowErrorInInterceptor: false });
      getAadharOtpNo(response);
  } catch (e) {
    getAadharOtpNo({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}
function* verifyAadhaarOtp({ payload }: any): Generator {
  const { verifyAadhaarOtpNumber } = payload;
  const sendRequest = SendRequest.instance;
  const { aadhaarOtp, txnID}: any = yield select((state: RootState): NewAdmissionState => state.newAdmission);

  const request: any = {
    otp: aadhaarOtp,
    txnId: txnID,
  };
  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.CRM_BASE_URL}/Health/Mobile/HealthLocker/Aadhar/VerifyOTP`, request,
      { isShowErrorInInterceptor: false });
      verifyAadhaarOtpNumber(response);
  } catch (e) {
    verifyAadhaarOtpNumber({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}
function* uploadDoc({ payload }: any): Generator {
  const { uploadDocuments } = payload;
  const sendRequest = SendRequest.instance;
  const { tempProfile, checkedFileList, uploadedFileList, doaValue, hospActionID}: any =
  yield select((state: RootState): NewAdmissionState => state.newAdmission);
  const { hospActionId: hospitalActionId, doa: dataOfAdmission}: any =
  yield select((state: RootState): any => state.admissionDetails.claimDetails);

  const filteredDocumentList: any[] = [];
  checkedFileList?.map((item: any): any =>
  (filteredDocumentList?.push(uploadedFileList?.filter((item2: any): any =>
    Array.isArray(item) ? (item2['documentGuid'] === item['documentGuid']) : (item2['documentGuid'] === item))[0])));
  let finalDocUploadType: any[] = [];
  filteredDocumentList?.map((e: any): any => {
    if (e?.documenttype) {
      if (Array.isArray(e?.documenttype)) {
        finalDocUploadType = [...finalDocUploadType, ...e?.documenttype];
      } else {
        finalDocUploadType.push(e?.documenttype);
      }
    }
  });
  const request: any = {
    profileId: tempProfile?.id,
    bucketName: tempProfile?.bucketName,
    hospActionId: (hospitalActionId === undefined || hospitalActionId === null) ? hospActionID : hospitalActionId,
    doa: (dataOfAdmission === undefined || dataOfAdmission === null) ? doaValue : dataOfAdmission,
    documenttypes: finalDocUploadType,
    documentList: filteredDocumentList,
  };
  try {
    const response: any = yield sendRequest.post(`${GLOBAL_URL.CRM_BASE_URL}api/HealthLocker/UploadDoc`, request,
      { isShowErrorInInterceptor: false });
    uploadDocuments(response);
  } catch (e) {
    uploadDocuments({ isSuccess: false, errors: [COMMON_ERROR] });
  }
}

export function* watchFile(): any {
  yield takeEvery(actionTypes.DOWNLOAD_FILE, downloadFile);
  yield takeEvery(actionTypes.PREVIEW_FILE, previewFile);
  yield takeEvery(actionTypes.DOWNLOAD_ALL_FILES, downloadAllFiles);
  yield takeEvery(actionTypes.BUDDHIMED_FILE_UPLOAD, getDocumentType);
  yield takeEvery(actionTypes.VERIFY_MOBILE_NUMBER, getMobileOtp);
  yield takeEvery(actionTypes.VERIFY_MOBILE_OTP, verifyMobileOtp);
  yield takeEvery(actionTypes.VERIFY_AADHAR_NUMBER, getAadharOtp);
  yield takeEvery(actionTypes.VERIFY_AADHAAR_OTP, verifyAadhaarOtp);
  yield takeEvery(actionTypes.UPLOAD_DOC, uploadDoc);
  yield takeEvery(actionTypes.HIS_FILE_DOWNLOAD, hisDownloadAllFiles);
}

export default watchFile;
